/**
 * The four user-facing SRS stages a card can be in. Ordered from least to most
 * progressed so callers can compare them by index (see {@link USER_CARD_STAGE_INDEX}).
 *
 * A card's stage is driven purely by the FSRS interval assigned at its last
 * review — "how far out did this review push the next one" (see
 * `lib/cards/user-card/mastery`). The bands are: New (< 1 week), Familiar
 * (>= 1 week), Proficient (>= 1 month), Mastered (>= 3 months).
 *
 * Stage-resolution logic (mapping an FSRS card to one of these) lives in
 * `lib/cards/user-card/mastery` to keep this package dependency-free.
 */
export const USER_CARD_STAGE_ORDER = ["new", "familiar", "proficient", "mastered"] as const;

export type UserCardStage = (typeof USER_CARD_STAGE_ORDER)[number];

export const USER_CARD_STAGE_LABEL: Record<UserCardStage, string> = {
  familiar: "Familiar",
  mastered: "Mastered",
  new: "New",
  proficient: "Proficient",
};

export const USER_CARD_STAGE_INDEX: Record<UserCardStage, number> = {
  familiar: 1,
  mastered: 3,
  new: 0,
  proficient: 2,
};
